import React from 'react';
import {
    BaseOperateView,
    BaseStagePlugin,
    getFramework,
    useActiveFrameId,
    useIdentity,
    useIsLongImageMode,
} from '@/framework';
import type { EliminatePenPlugin } from '../plugin-instance';
import { useEliminatePenState } from '../states/eliminate-pen-state';
import { EliminatePen } from './eliminate-pen';

export const EliminatePenPluginView: React.FC = React.memo(() => {
    const originIndex = useActiveFrameId();
    const isLongImageMode = useIsLongImageMode();
    const identity = useIdentity();
    const framework = getFramework(identity);
    const originLayer = useEliminatePenState()((state) => state.originLayer);
    const instance = framework.service.registration.getInstance<EliminatePenPlugin>('EliminatePenPlugin');
    const panel = instance.getPanel();

    // ATTENTION: 插件仅处理单画布的主图场景
    if (!originLayer || isLongImageMode) return null;

    return (
        <BaseStagePlugin enablePointerEvents name="main-layer-eliminate-pen">
            <EliminatePen originLayer={originLayer} originIndex={originIndex} />
            <BaseOperateView
                layer={framework.service.frame.getBaseInfo(originIndex)}
                offsetTop={0}
                offsetRight={0}
                style={{ position: 'relative' }}
            >
                <div
                    style={{
                        position: 'absolute',
                        left: '50%',
                        bottom: '0',
                        transform: 'translateX(-50%) translateY(100%)',
                        pointerEvents: 'all',
                    }}
                >
                    {panel}
                </div>
            </BaseOperateView>
        </BaseStagePlugin>
    );
});
